import { atom } from "recoil";

export const addStateArea = atom({
  key: "addStateArea",
  default: false,
});
export const editStateArea = atom({
  key: "editStateArea",
  default: false,
});
export const rowEditIdStateArea = atom({
  key: "rowEditIdStateArea",
  default: null,
});
export const disableButtonStateArea = atom({
  key: "disableButtonStateArea",
  default: false,
});

export const rowForEditStateArea = atom({
  key: "rowForEditStateArea",
  default: [],
});

export const selectedRowsStateArea = atom({
  key: "selectedRowsStateArea",
  default: [],
});

export const setFilterTextArea = atom({
  key: "setFilterTextArea",
  default: "",
});

export const setCheckStatusStateArea = atom({
  key: "setCheckStatusStateArea",
  default: false,
});

export const setLinkStateArea = atom({
  key: "setLinkStateArea",
  default: false,
});
export const setButtonLinkTextStateArea = atom({
  key: "setButtonLinkTextStateArea",
  default: "",
});

export const setHierarchyIdStateArea = atom({
  key: "setHierarchyIdStateArea",
  default: "",
});

export const setHiddenColumnStateArea = atom({
  key: "setHiddenColumnStateArea",
  default: false,
});

export const setDescriptionAreaState = atom({
  key: "setDescriptionAreaState",
  default: "",
});

export const getHierarchyType = atom({
  key: "getHierarchyType",
  default: ""
});